const ALL_IDENTIFIER = "all";
const DATAQUERY_VALUES_SEPARATOR = "+";
const DATAQUERY_DIMENSIONS_SEPARATOR = ".";
export {
  ALL_IDENTIFIER,
  DATAQUERY_DIMENSIONS_SEPARATOR,
  DATAQUERY_VALUES_SEPARATOR
};
